module.exports = __webpack_public_path__ + "assets/devices/TOWER-30-PG2-2ba30c0766b687a9158b3f3fe5b295f4.svg";